import React from 'react';
import { Container, Grid, Typography, Card, CardContent, Button } from '@mui/material';
import { IoIosDoneAll } from 'react-icons/io';
import LogoSnsf from '../../assets/images/Logosnsf.png';
import './Convenios.css'

export default function Convenios() {
    return (
        <div>
            <div className="convenios">
                <Container>
                    <Grid container justifyContent="center">
                        <Grid item>
                        <Typography
             variant="h1"
             align="center"
             gutterBottom
             style={{
               fontFamily: "'Lato', serif",
               color: "white",
               borderBottom: "4px solid #d4af37",
               paddingBottom: "10px",
               textTransform: "uppercase",
               animation: "glow 2s infinite alternate",
               marginTop: "7%"  // Aqui é onde você define o espaço superior
             }}
           > 
                                Convênios
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </div>

            <section className="convenio-section">
                <Container>
                 
  
                    <Grid container spacing={4}>
                    <Typography
    variant="h2"
    align="center"
    gutterBottom
    style={{
      fontFamily: "'Lato', serif",
      color: "#1f1e1e",
      borderBottom: "4px solid #d4af37",
      paddingBottom: "10px",
      textTransform: "uppercase",
      animation: "glow 2s infinite alternate",
      marginTop: "7%"  // Aqui é onde você define o espaço superior
    }}
  >
     Instrução e conversão no mundo dos exempla ibéricos: pilares da moral cristã

        </Typography>
                        <Grid item xs={12} md={6}>
                             
                            <Card>

                                <CardContent>
                                    <img className="img-fluid" src={LogoSnsf} alt="Logo SNSF" />
                                </CardContent>
                            </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                          
                                <CardContent>
                                     
                                    <Typography variant="body1" color="textSecondary" paragraph>
                                        O presente projeto vem propor a criação de um núcleo de pesquisa internacional e
                                        interdisciplinar com dupla sede, a Universidade Estadual de Campinas (UNICAMP) e a
                                        Université de Fribourg (Suíça), que se dedicará aos estudos das funções edificantes das
                                        recolhas de exempla produzidas ou compiladas em línguas vernáculas na Península Ibérica
                                        do século XIII ao XVI. Envolvendo pesquisadores de universidades brasileiras e europeias -
                                        como a Université de Genève (Suíça), Universidade de São Paulo (USP), Universidade
                                        Federal de São Paulo (UNIFESP), Universidad de León (Espanha) e a Universidade Estadual
                                        Paulista (UNESP) - a proposta consistirá em examinar jogos de aprendizagem da moral
                                        cristã em que as historietas moralizantes se tornaram peças-chave para facilitar a
                                        memorização de tipos de condutas recomendadas ou recriminadas mediante à exemplificação
                                        de virtudes e pecados. Esta pesquisa abordará o processo de naturalização de crenças
                                        cristãs em solo ibérico a partir da análise do papel atribuído ao exemplum no ensino de
                                        comportamentos promovidos nas cortes régias e nas pregações populares, de modo que será
                                        considerado o seu público-alvo e meio de circulação. Como norte da análise desse roteiro
                                        de condutas, o núcleo examinará em que medida os exempla reforçaram uma disciplina que
                                        visava ensinar cuidados a serem tomados consigo, com o próprio corpo e a alma, bem como
                                        com o seu grupo social. Nesse sentido, os seus pesquisadores examinarão narrativas que
                                        procuravam estabelecer critérios para ação em dois âmbitos da vida, na relação consigo
                                        e com os outros.
                                    </Typography>
                                </CardContent>
                            
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Processo: 21/02936-0
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Linha de fomento: Auxílio à Pesquisa - Regular
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Vigência: 01 de outubro de 2021 - 30 de setembro de 2025
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Área do conhecimento: Ciências Humanas - História
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Pesquisador responsável: Leandro Alves Teodoro
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Beneficiário: Leandro Alves Teodoro
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Pesq. responsável no exterior: Hugo Bizzarri
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Instituição no exterior: Université de Fribourg, Suíça
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Instituição-sede: Instituto de Filosofia e Ciências Humanas (IFCH). Universidade Estadual de Campinas (UNICAMP). Campinas, SP, Brasil
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Pesquisadores associados: Abraham Madroñal Durán, Ana Paula Tavares Magalhães Tacconi, Bruno Guilherme Feitler, María Luzdivina Cuesta Torre
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6">
                                <IoIosDoneAll /> Assunto(s): Península Ibérica, Língua vernacular, Manuscritos, Moral cristã, Narrativas moralizantes
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>

                <div className="pdf-tbn-evento">
                <Button
                                 variant="contained"
                                 color="primary"
                                 href="https://bv.fapesp.br/pt/auxilios/108932/instrucao-e-conversao-no-mundo-dos-exempla-ibericos-pilares-da-moral-crista/"
                                 target="_blank"
                                 rel="noopener noreferrer"
                                whileHover={{ scale: 1.1 }}
                                transition={{ type: 'spring', stiffness: 300 }}
                                sx={{
                                    backgroundColor: '#d4af37',
                                    color: '#faf9f9',
                                    padding: '12px 24px',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    borderRadius: '50px',
                                    transition: 'transform 0.3s ease, background-color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: '#800020',
                                    },
                                }}
                            >
                     
                        Ver Publicação
                    </Button>
                </div>
            </section>
        </div>
    );
}